import { FunctionComponent, lazy } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";

import FormLayout from 'layouts/form/FormLayout';
import SimpleLayout from 'layouts/simple/SimpleLayout';

import RegistrationRoute from 'components/routing/RegistrationRoute';
import TestModeRoute from 'components/routing/TestModeRoute';

import { TEST_ROUTE_BASE } from 'services/testMode';

const StartPage = lazy(() => import('pages/start/StartPage'));
const ImpressumPage = lazy(() => import('pages/impressum/ImpressumPage'));
const PrivacyPage = lazy(() => import('pages/privacy/PrivacyPage'));
const DisclaimerPage = lazy(() => import('pages/disclaimer/DisclaimerPage'));
const Error404Page = lazy(() => import('pages/error/Error404Page'));
const InsuranceCardPage = lazy(() => import('pages/registration/insurance_card/InsuranceCardPage'));
const PersonalDetailsPage = lazy(() => import('pages/registration/personal_details/PersonalDetailsPage'));
const EmployerPage = lazy(() => import('pages/registration/employer/EmployerPage'));
const MedicalAppointmentPage = lazy(() => import('pages/registration/medical_appointment/MedicalAppointmentPage'));
const InsuranceRelationshipPage = lazy(() => import('pages/registration/insurance_relationship/InsuranceRelationshipPage'));
const CheckoutPage = lazy(() => import('pages/registration/checkout/CheckoutPage'));
const CheckoutSuccessPage = lazy(() => import('pages/registration/checkout_success/CheckoutSuccessPage'));

// Route children are shared between the public tree and its /{TEST_ROUTE_BASE}/ mirror
// so the two stay in sync; only the "index" redirect target differs between them.
const registrationRoutes = (indexRedirectPath: string) =>
    <>
        <Route index element={<Navigate to={{ pathname: indexRedirectPath }} />} />
        <Route path='insurancecard' element={<RegistrationRoute outlet={<InsuranceCardPage />} />} />
        <Route path='personal_details' element={<RegistrationRoute outlet={<PersonalDetailsPage />} />} />
        <Route path='employer' element={<RegistrationRoute outlet={<EmployerPage />} />} />
        <Route path='medical_appointment' element={<RegistrationRoute outlet={<MedicalAppointmentPage />} />} />
        <Route path='insurance_relationship' element={<RegistrationRoute outlet={<InsuranceRelationshipPage />} />} />
        <Route path='checkout' element={<RegistrationRoute outlet={<CheckoutPage />} />} />
        <Route path="*" element={<Error404Page />} />
    </>

const simpleRoutes =
    <>
        <Route index element={<StartPage />} />
        <Route path="impressum" element={<ImpressumPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="disclaimer" element={<DisclaimerPage />} />
        <Route path='checkout_success' element={<RegistrationRoute outlet={<CheckoutSuccessPage />} />} />
        <Route path="*" element={<Error404Page />} />
    </>

const AppRoutes: FunctionComponent = () =>
    <Routes>
        <Route path="/registration/" element={<FormLayout />}>
            {registrationRoutes('/')}
        </Route>
        <Route path="/" element={<SimpleLayout />}>
            {simpleRoutes}
        </Route>
        <Route path="/:locale" element={<SimpleLayout />}>
            {simpleRoutes}
        </Route>

        {/* Mirrors the trees above under /{TEST_ROUTE_BASE}/, bypassing maintenance mode for internal testing */}
        <Route path={TEST_ROUTE_BASE} element={<TestModeRoute />}>
            <Route path="registration" element={<FormLayout />}>
                {registrationRoutes(`/${TEST_ROUTE_BASE}`)}
            </Route>
            <Route element={<SimpleLayout />}>
                {simpleRoutes}
            </Route>
        </Route>
    </Routes>

export default AppRoutes;
